import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormGroup, Form } from 'react-bootstrap';
import styles from './styles.module.css';

const DatePicker = (props) => {
  const {
    containerClassName,
    disabled,
    idPrefix,
    error,
    label,
    labelClassName,
    value,
    minDate,
    maxDate,
    minPreviousDays,
    maxFutureDays,
    minPreviousMonths,
    maxFutureMonths,
    minPreviousYears,
    maxFutureYears,
    onChange,
  } = props;

  const [isInvalid, setIsInvalid] = useState(false);

  const handleChange = (event) => {
    const inputValue = event.target.value;
    const timestamp = inputValue ? new Date(inputValue).getTime() : 0;
    let isValid = true;

    if (inputValue) {
      if (minDt && inputValue < minDt) {
        isValid = false;
      }
      if (maxDt && inputValue > maxDt) {
        isValid = false;
      }

      if (!isValid) {
        setIsInvalid(true);
        setTimeout(() => {
          setIsInvalid(false);
        }, 1000);
        return;
      }
    }

    setIsInvalid(false);

    if (onChange) {
      onChange(timestamp);
    }
  };

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  let minDt = minDate ? formatDate(new Date(minDate)) : null;
  let maxDt = maxDate ? formatDate(new Date(maxDate)) : null;

  if (minPreviousDays && !minDate) {
    const date = new Date();
    date.setDate(date.getDate() - minPreviousDays);
    minDt = formatDate(date);
  }

  if (minPreviousMonths && !minDate) {
    const date = new Date();
    date.setMonth(date.getMonth() - minPreviousMonths);
    minDt = formatDate(date);
  }

  if (minPreviousYears && !minDate) {
    const date = new Date();
    date.setFullYear(date.getFullYear() - minPreviousYears);
    minDt = formatDate(date);
  }

  if (maxFutureDays && !maxDate) {
    const date = new Date();
    date.setDate(date.getDate() + maxFutureDays);
    maxDt = formatDate(date);
  }

  if (maxFutureMonths && !maxDate) {
    const date = new Date();
    date.setMonth(date.getMonth() + maxFutureMonths);
    maxDt = formatDate(date);
  }

  if (maxFutureYears && !maxDate) {
    const date = new Date();
    date.setFullYear(date.getFullYear() + maxFutureYears);
    maxDt = formatDate(date);
  }

  return (
    <FormGroup className={classnames(styles.root, containerClassName)}>
      {!props.label ? null : (
        <Form.Label
          className={`label ${styles.label} ${labelClassName} ${error ? 'labelError' : null}`}
        >
          {label}
        </Form.Label>
      )}
      <Form.Control
        data-cy-id={`${idPrefix}-DatePicker`}
        className={`${styles.dateInput} ${isInvalid ? styles.invalid : ''}`}
        disabled={disabled}
        min={minDt}
        max={maxDt}
        onChange={handleChange}
        type="date"
        value={value ? formatDate(new Date(value)) : ''}
      />
    </FormGroup>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.any,
  idPrefix: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  minDate: PropTypes.number,
  maxDate: PropTypes.number,
  minPreviousDays: PropTypes.number,
  maxFutureDays: PropTypes.number,
  minPreviousMonths: PropTypes.number,
  maxFutureMonths: PropTypes.number,
  minPreviousYears: PropTypes.number,
  maxFutureYears: PropTypes.number,
};

export default DatePicker;
